export default "__VITE_ASSET__n5nSkJKH__"